import React from "react";
import * as AV from "../../AVCore/AVCore";
import {
  Box,
  Button,
  HStack,
  Image,
  Input,
  Pressable,
  Text,
  Tooltip,
  VStack,
} from "native-base";
import {
  CalenderCardIcon,
  Event,
  LocationCardIcon,
  TeamBackground,
  TimerCardIcon,
} from "../../assets/icons/icon-assets";
import Moment from "moment";
import { Loc } from "../../App/Loc";

const EventCard = ({ item, handleEventClick, isShowRSVP = true }) => {
  let profileImg = item?.thumb ? item?.thumb : item?.profile?.pic?.id;
  let backgroundImg = item?.background
    ? item.background
    : item?.profile?.background?.id;

  let profileImage = "";
  let backgroundImage = "";

  if (item?.thumb) profileImage = AV.Media.getThumb(item);
  else if (item?.profile?.pic?.id)
    profileImage = AV.Media.getThumb(AV.AVEntity.getLink(item));

  if (item?.background) backgroundImage = AV.Media.getBackground(item);
  else if (item?.profile?.background?.id)
    backgroundImage = AV.Media.getBackground(AV.AVEntity.getLink(item));

  return (
    <Pressable
      width={"200px"}
      marginX={"10px"}
      marginY={"12px"}
      bgColor={"rgba(0,167,188,0.11)"}
      borderRadius={10}
      borderColor={"AVColor.bgcolor"}
      shadow={1}
      overflow={"hidden"}
      _hover={{
        shadow: 3,
      }}
      borderWidth={1}
      onPress={() => handleEventClick(item)}
    >
      <Box
        width={"100%"}
        height={"70px"}
        bgColor={"rgba(0,167,188,0.26)"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        {backgroundImg && (
          <Image
            source={{
              uri: backgroundImage,
            }}
            width={"100%"}
            height={"100%"}
            position={"absolute"}
            zIndex={-3}
          />
        )}
        {!backgroundImg && item?.type !== "Event" && <TeamBackground />}
        {profileImg ? (
          <Image
            source={{
              uri: profileImage,
            }}
            width={item?.type == "Event" ? "54px" : "84px"}
            height={item?.type == "Event" ? "54px" : "84px"}
            position={item?.type == "Event" ? undefined : "absolute"}
            borderRadius={"50%"}
            alt={"Profile Image"}
          />
        ) : (
          <>
            <Event height={"50"} width={"50"} color={"#32AE78"} />
          </>
        )}
      </Box>
      <VStack pt={1.5} justifyContent={"center"} space={1}>
        <HStack justifyContent={"center"} px={2}>
          <Tooltip
            label={item?.title ? item?.title : item?.name}
            openDelay={500}
          >
            <Pressable onPress={() => handleEventClick(item)}>
              <Text
                fontSize={"18px"}
                width={"200px"}
                color={"AVColor.primaryText"}
                numberOfLines={1}
                text-overflow={"ellipsis"}
                textAlign={"center"}
                fontWeight={500}
              >
                {item?.title ? item?.title : item?.name}
              </Text>
            </Pressable>
          </Tooltip>
        </HStack>

        <VStack px={2}>
          <HStack alignItems={"center"} space={"15px"} marginTop={"5px"}>
            <CalenderCardIcon height={"24"} width={"24"} color={"black"} />
            <Text color={"black"} fontSize={"14px"}>
              {Moment(item?.start).format("MM/DD/YYYY")}
            </Text>
          </HStack>
          <HStack alignItems={"center"} space={"15px"}>
            <TimerCardIcon height={"24"} width={"24"} color={"black"} />
            <Text color={"black"} fontSize={"14px"}>
              {Moment(item?.start).format("hh:mm A")} -{" "}
              {Moment(item?.end).format("hh:mm A")}
            </Text>
          </HStack>
          <HStack alignItems={"center"} space={"10px"}>
            <HStack width={"30px"}>
              <LocationCardIcon height={"24"} width={"24"} color={"black"} />
            </HStack>
            <Text numberOfLines={1} fontSize={"14px"} color={"black"}>
              {item?.locURL || item?.location?.title || item?.url}
            </Text>
          </HStack>
        </VStack>

        {isShowRSVP && (
          <HStack
            py={1}
            alignItems={"center"}
            justifyContent={"center"}
            backgroundColor={"rgba(0,167,188,1)"}
            // height={"25px"}
          >
            <Text
              fontSize="14px"
              color={"rgba(255,255,255,1)"}
              fontWeight={500}
              textAlign="center"
            >
              {item?.status === "Yes"
                ? Loc.currentLang.menu.attending
                : item?.status === "No"
                  ? Loc.currentLang.menu.notAttending
                  : item?.status === "Maybe"
                    ? Loc.currentLang.menu.maybe
                    : item?.status === "New"
                      ? Loc.currentLang.menu.rsvp
                      : item?.status === "Canceled"
                        ? Loc.currentLang.menu.canceled
                        : Loc.currentLang.menu.rsvp}
            </Text>
          </HStack>
        )}
      </VStack>
    </Pressable>
  );
};

export default EventCard;
